import ApiService from '../../../../../services/ApiService'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'
import ManageWorkHours from '../manageWorkHours/ManageWorkHours.vue'

export default {
  components: {
    InstitutionInactive,
    ManageWorkHours,
  },

  props: {
    title: String,
    unidade: Object,
  },

  created() {
    this.getInstitutions()
    this.getStates()
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    const institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = institution.id
    this.institutionInactive = institution.status == 1

    if (this.unidade) {
      this.currentUnidade = {
        ...this.currentUnidade,
        ...this.unidade,
      }
      this.isEditing = true

      if (this.unidade.id) {
        this.loadWorkHours()
      }
      if (this.unidade.state) {
        this.getCities()
      }    }
  },

  data: () => ({
    loading: false,
    step: 0,
    firstValid: true,
    secondValid: true,
    thirdValid: true,
    error: false,
    errorMessage: '',
    isEditing: false,
    institutionInactive: false,
    institutionId: null,
    institutions: [],
    states: [],
    cities: [],
    statesLoading: false,
    citiesLoading: false,
    inputDisabled: true,
    userLogged: {},
    workHoursDialog: false,
    workHoursDialogKey: false,
    currentWorkHour: null,
    workHours: [],
    workHoursLoading: false,
    deleteWorkHourDialog: false,
    deleteWorkHourLoading: false,
    workHourToDelete: null,
    currentUnidade: {
      hasAcess: false,
      name: '',
      initials: '',
      cnpj: '',
      phone: '',
      address: '',
      district: '',
      locationNumber: '',
      complement: '',
      city: '',
      state: '',
      emailResponsibleToQual: '',
      emailResponsibleToLeave: '',
      workingHoursStart: '00:00',
      workingHoursEnd: '23:59',
      worksOnWeekends: false,
      serviceTimeEquipmentLowCriticality: '00:00',
      resolutionTimeEquipmentLowCriticality: '000',
      serviceTimeEquipmentMediumCriticality: '00:00',
      resolutionTimeEquipmentMediumCriticality: '000',
      serviceTimeEquipmentHighCriticality: '00:00',
      resolutionTimeEquipmentHighCriticality: '000',
      contacts: [],
    },
    nameRules: [
      (v) => !!v || 'Nome requerido',
      (v) => (v && v.length <= 128) || 'Nome deve ter no máximo 128 caracteres',
    ],
    initialsRules: [
      (v) => !!v || 'Sigla requerida',
      (v) => (v && v.length <= 4) || 'Sigla deve ter no máximo 4 caracteres',
    ],
    phoneRules: [(v) => !!v || 'Telefone requerido'],
    addressRules: [
      (v) => !!v || 'Logradouro requerido',
      (v) => v.length <= 64 || 'Logradouro deve ter no máximo 64 caracteres',
    ],
    districtRules: [
      (v) => !!v || 'Bairro requerido',
      (v) => v.length <= 32 || 'Bairro deve ter no máximo 32 caracteres',
    ],
    complementRules: [
      (v) => v.length <= 64 || 'Complemento deve ter no máximo 64 caracteres',
    ],
    cityRules: [
      (v) => !!v || 'Cidade requerido',
      (v) => v.length <= 32 || 'Cidade deve ter no máximo 32 caracteres',
    ],
    stateRules: [
      (v) => !!v || 'Estado requerido',
      (v) => v.length <= 2 || 'Estado deve ter no máximo 2 caracteres',
    ],
    serviceTimeRules: [
      (v) => /^\d\d:\d\d/.test(v) || 'Horário em formato inválido',
    ],
    workingHoursRules: [
      (v) => !!v || 'Horário de funcionamento é obrigatório',
      (v) => /^\d\d:\d\d$/.test(v) || 'Horário em formato inválido (HH:MM)',
      (v) => {
        const [hours, minutes] = v.split(':').map(Number)
        return (hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59) || 'Horário inválido'
      },
    ],
    emailRules: [(v) => /.+@.+\..+/.test(v) || 'E-mail inválido'],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Informações Iniciais'
        case 1:
          return 'Localização'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return 'Continuar'
        case 1:
          return this.isEditing ? 'Atualizar' : 'Cadastrar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    openWorkHours() {
      this.currentWorkHour = null
      this.workHoursDialogKey = !this.workHoursDialogKey
      this.workHoursDialog = true
    },

    openEditWorkHour(workHour) {
      this.currentWorkHour = workHour
      this.workHoursDialogKey = !this.workHoursDialogKey
      this.workHoursDialog = true
    },

    openDeleteWorkHour(workHour) {
      this.workHourToDelete = workHour
      this.deleteWorkHourDialog = true
    },

    async confirmDeleteWorkHour() {
      this.deleteWorkHourLoading = true
      try {
        const response = await this.apiService.delete(`UnitWorkHours/delete/${this.workHourToDelete.id}`)
        if (response.statusCode === 200) {
          this.$toast.success('Horário excluído com sucesso!')
          await this.loadWorkHours()
          this.deleteWorkHourDialog = false
          this.workHourToDelete = null
        } else {
          this.$toast.error(response.message || 'Erro ao excluir horário')
        }
      } catch (error) {
        this.$toast.error('Erro ao excluir horário')
      } finally {
        this.deleteWorkHourLoading = false
      }
    },

    async loadWorkHours() {
      if (!this.currentUnidade.id) return
      this.workHoursLoading = true
      try {
        const response = await this.apiService.get(`UnitWorkHours/list/${this.currentUnidade.id}`)
        if (response.statusCode === 200) {
          this.workHours = response.content || []
        }
      } catch (error) {
        console.error('Erro ao carregar horários:', error)
      } finally {
        this.workHoursLoading = false
      }
    },

    formatWeekDays(days) {
      if (!days || days.length === 0) return ''
      const dayNames = {
        0: 'Domingo',
        1: 'Segunda-feira',
        2: 'Terça-feira',
        3: 'Quarta-feira',
        4: 'Quinta-feira',
        5: 'Sexta-feira',
        6: 'Sábado',
        Monday: 'Segunda-feira',
        Tuesday: 'Terça-feira',
        Wednesday: 'Quarta-feira',
        Thursday: 'Quinta-feira',
        Friday: 'Sexta-feira',
        Saturday: 'Sábado',
        Sunday: 'Domingo',
      }
      const orderMap = {
        0: 6,
        1: 0,
        2: 1,
        3: 2,
        4: 3,
        5: 4,
        6: 5,
        Monday: 0,
        Tuesday: 1,
        Wednesday: 2,
        Thursday: 3,
        Friday: 4,
        Saturday: 5,
        Sunday: 6,
      }
      return [...days]
        .sort((a, b) => (orderMap[a] ?? 99) - (orderMap[b] ?? 99))
        .map((d) => dayNames[d] || dayNames[String(d)] || '')
        .filter(Boolean)
        .join(', ')
    },

    formatTimeRange(workHour) {
      const sh = String(workHour.startHour ?? '').padStart(2, '0')
      const sm = String(workHour.startMinute ?? '').padStart(2, '0')
      const eh = String(workHour.endHour ?? '').padStart(2, '0')
      const em = String(workHour.endMinute ?? '').padStart(2, '0')
      return `${sh}:${sm} às ${eh}:${em}`
    },

    formatSpecificDate(dateStr) {
      if (!dateStr) return ''
      return new Date(dateStr).toLocaleDateString('pt-BR')
    },

    addContact() {
      this.currentUnidade.contacts.push({})
    },

    removeContact(index) {
      this.currentUnidade.contacts.splice(index, 1)
    },

    uppercase() {
      this.currentUnidade.initials = this.currentUnidade.initials.toUpperCase()
      this.currentUnidade.state = this.currentUnidade.state.toUpperCase()
    },

    close() {
      this.$emit('close')
    },

    validarCNPJ(cnpj) {
      cnpj = cnpj.replace(/[^\d]+/g, '')

      if (cnpj == '') return false

      if (cnpj.length != 14) return false

      // Elimina CNPJs invalidos conhecidos
      if (
        cnpj == '00000000000000' ||
        cnpj == '11111111111111' ||
        cnpj == '22222222222222' ||
        cnpj == '33333333333333' ||
        cnpj == '44444444444444' ||
        cnpj == '55555555555555' ||
        cnpj == '66666666666666' ||
        cnpj == '77777777777777' ||
        cnpj == '88888888888888' ||
        cnpj == '99999999999999'
      )
        return false

      // Valida DVs
      let tamanho = cnpj.length - 2
      let numeros = cnpj.substring(0, tamanho)
      let digitos = cnpj.substring(tamanho)
      let soma = 0
      let pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(0)) return false

      tamanho = tamanho + 1
      numeros = cnpj.substring(0, tamanho)
      soma = 0
      pos = tamanho - 7
      for (let i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--
        if (pos < 2) pos = 9
      }
      resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
      if (resultado != digitos.charAt(1)) return false

      return true
    },

    async getInstitutions() {
      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
      })
    },

    async getStates() {
      this.statesLoading = true
      await this.apiService
        .get('address/states')
        .then((response) => {
          this.states = response.content.map((uf) => uf.sigla).sort()
          this.statesLoading = false
        })
        .catch((err) => {
          this.errorMessage = err?.body?.message || 'Erro ao buscar estados'
          this.error = true
          setTimeout(() => { this.error = false }, 4000)
        })
    },

    async getCities() {
      this.citiesLoading = true
      await this.apiService
        .get(`address/cities?state=${this.currentUnidade.state}`)
        .then((response) => {
          this.cities = response.content.map((city) => city.nome).sort()
          this.citiesLoading = false
        })
        .catch((err) => {
          this.errorMessage = err?.body?.message || 'Erro ao buscar cidades'
          this.error = true
          setTimeout(() => { this.error = false }, 4000)
        })
    },

    async searchCEP() {
      if (!this.inputDisabled) return
      const cep = this.currentUnidade.cep.replace(/[^0-9]/g, '')
      if (cep.length < 8) return
      await this.apiService
        .get(`address/postalcode?cep=${cep}`)
        .then(async (response) => {
          const location = response.content
          this.currentUnidade.address = location.logradouro || ''
          this.currentUnidade.district = location.bairro || ''
          if (location.uf) {
            this.currentUnidade.state = location.uf
            await this.getCities()
            if (location.localidade) {
              const norm = location.localidade.toUpperCase()
              const match = this.cities.find((c) => c.toUpperCase() === norm)
              this.currentUnidade.city = match || location.localidade
            }
          }
        })
        .catch((err) => {
          this.errorMessage = err?.body?.message || 'CEP não encontrado'
          this.error = true
          this.currentUnidade.address = ''
          this.currentUnidade.district = ''
          setTimeout(() => { this.error = false }, 4000)
        })
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.step += 1
        }
      } else if (this.step === 1) {
        if (this.$refs.secondForm.validate()) {
          await this.submit()
        }
      } else {
        this.close()
      }
    },

    back() {
      this.step -= 1
    },

    maskPhone() {
      if (!!this.currentUnidade.phone) {
        return this.currentUnidade.phone.length === 13
          ? '(##) ####-####'
          : '(##) #####-####'
      }
    },

    async submit() {
      this.loading = true

      const unidade = {
        Id: this.currentUnidade.id,
        InstitutionId: this.institutionId,
        Name: this.currentUnidade.name,
        Initials: this.currentUnidade.initials,
        Cnpj: this.currentUnidade.cnpj,
        Phone: this.currentUnidade.phone,
        Cep: this.currentUnidade.cep,
        Address: this.currentUnidade.address,
        District: this.currentUnidade.district,
        LocationNumber: this.currentUnidade.locationNumber,
        Complement: this.currentUnidade.complement,
        City: this.currentUnidade.city,
        State: this.currentUnidade.state,
        EmailResponsibleToQual: this.currentUnidade.emailResponsibleToQual,
        EmailResponsibleToLeave: this.currentUnidade.emailResponsibleToLeave,
        WorkingHoursStart: this.currentUnidade.workingHoursStart,
        WorkingHoursEnd: this.currentUnidade.workingHoursEnd,
        WorksOnWeekends: this.currentUnidade.worksOnWeekends,
        contacts: this.currentUnidade.contacts,
      }

      let url = 'unidade/add'

      if (this.isEditing) {
        url = 'unidade/edit'
      } else {
        unidade.HasAcess = this.currentUnidade.hasAcess
      }

      await this.apiService
        .post(url, unidade)
        .then(() => {
          this.loading = false
          this.step += 1
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true
          this.loading = false

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },
  },

  watch: {
    inputDisabled(val) {
      if (val) {
        this.searchCEP()
      }
    },
  },
}
